<template>
  <div class="SelectlContractDetail">
    <div class="tabWrap">
      <el-tabs style="width: 100%" v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dialogForm"
              label-width="150px"
              :inline="true"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同编号">
                    <el-input
                      v-model="dialogForm.serialNumber"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同名称">
                    <el-input
                      v-model="dialogForm.name"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同甲方">
                    <el-input
                      v-model="dialogForm.partyA"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同乙方">
                    <el-input
                      v-model="dialogForm.partyB"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <el-form-item label="合同金额">
                    <el-input
                      v-model="dialogForm.amount"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="间接费比例">
                    <el-input
                      v-model="dialogForm.indirectExpPct"
                      :readonly="true"
                    >
                      <i slot="suffix">%</i>
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="间接费金额">
                    <el-input
                      v-model="dialogForm.indirectExp"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="暂定金金额">
                    <el-input
                      v-model="dialogForm.provisionalAmount"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="签订日期">
                    <el-date-picker
                      v-model="dialogForm.signDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      :readonly="true"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="签订地点">
                    <el-input
                      v-model="dialogForm.signPlace"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="合同分类">
                    <el-input
                      v-model="dialogForm.typeValue"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="缺陷责任期">
                    <el-input
                      v-model="dialogForm.liabilityPeriod"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="工期">
                    <el-input
                      v-model="dialogForm.projectTime"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="付款约定">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="dialogForm.agreeOn"
                      maxlength="566"
                      style="width: 100%; min-width: 566px"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="dialogForm.comments"
                      maxlength="566"
                      style="width: 100%; min-width: 566px"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="申请人">
                    <el-input
                      v-model="dialogForm.applyUserName"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申请部门">
                    <el-input
                      v-model="dialogForm.applyDeptName"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="dialogForm.approveStatus == '3'">
                <el-col :span="12">
                  <el-form-item label="项目部">
                    <el-input
                      v-model="dialogForm.chargeDeptName"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="项目经理">
                    <el-input
                      v-model="dialogForm.chargeUserName"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="7">
                  <el-form-item label="单据状态:">{{
                    dialogForm.approveStatusName
                  }}</el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="流水号:">{{
                    dialogForm.flowNo
                  }}</el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="单据日期:">{{
                    dialogForm.createTime
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="7">
                  <el-form-item
                    label=""
                    v-if="dialogForm.contractType === 'ADDITIONAL'"
                    ><el-button type="text" @click="openContract">{{
                      dialogForm.relatedSerialNumberShow
                    }}</el-button></el-form-item
                  >
                  <el-form-item label="" v-else
                    ><el-button type="text" @click="openContract">{{
                      dialogForm.relatedSerialNumberShow
                    }}</el-button></el-form-item
                  >
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="工程量清单"
          name="second"
          style="text-align: left"
          class="firstTab"
          v-if="dialogForm.contractType !== 'TEMPORARY'"
        >
          <EngineerList
            :engineerItems="dialogForm.generalContractProjectDetailsVOs"
            :projectDetailsTotalPrice="dialogForm.projectDetailsTotalPrice"
          ></EngineerList>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="third"
          style="text-align: left"
          class="firstTab"
        >
          <upLoadFileDialog
            :itemVOs="dialogForm.contractItemVOs"
            :itemId="contractId"
            :approveStatus="dialogForm.approveStatus"
            :type="approveType"
            :isUploadAllowed="dialogForm.isUploadAllowed"
            @saveUpdateFile="getContractDetail(contractId)"
          ></upLoadFileDialog>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fourth"
          style="text-align: left;"
          class="firstTab"
        >
          <div v-if="approveFlag === 'currentApprove'">
            <approveItem
              :itemId="contractId"
              :approveType="approveType"
              :subapproveType="subapproveType"
              @finishApprove="close1"
            >
            </approveItem>
          </div>
          <div v-else>
            <approveLine
              :itemId="contractId"
              :approveType="approveType"
            ></approveLine>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="info" @click="close1">关 闭</el-button>
    </div>
  </div>
</template>

<script>
import {
  getContractDetailService, //获取一条总包合同信息
  getBasicDataListService, //获取合同分类接口
} from "@/services/allContractServices";
import EngineerList from "../commonCell/selectEngineerList"; //总包合同工程量清单tab页
import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
import approveItem from "@/page/approveComponents/ApproveItem"; //历史审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件
import { numFilter } from "@/utils/filters";
import {goBackApprove} from '@/page/approveComponents/approve'

export default {
  name: "SelectlContractDetail",
  components: {
    approveLine, //审批历史流程
    approveItem, //审批
    EngineerList, //工程量清单
    upLoadFileDialog, //上传附件
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveType: "GENERAL_CONTRACT", //审批类型
      subapproveType: "TotalContract", // 审批子类型
      approveFlag: "", //'currentApprove' 审批项目 'waitApproveDetail' 待审批列表进审批详情 'historyApproveDetail' 审批历史列表进审批详情
      islastApproveUser: false, //是否为最后一位审批人
      RouteParam: {}, //存储路由跳转参数
      contractId: 0, //总包合同ID
      category: "GENERALCONTRACTTYPE", //合同分类
      ContractClassList: [], //合同分类下拉框数据
      currentUserId: "",

      dialogForm: {
        id: 0,
        serialNumber: "", // 合同编号
        name: "", //合同名称
        partyA: "", //合同甲方
        partyB: "", //合同乙方
        projectTime: "", //工期
        provisionalAmount: "", //暂定金金额
        signDate: "", //签订日期
        signPlace: "", //签订地点
        amount: 0, //合同金额
        applyDeptId: 0, //申请人部门ID
        applyDeptName: "", //申请人部门名称
        applyUserId: 0, //申请人ID
        applyUserName: "", //申请人姓名
        approveUserId: "", //当前审批人
        comments: "", //备注
        indirectExp: 0, //间接费金额
        indirectExpPct: 0, //间接费比例
        approveStatus: null, //单据状态
        agreeOn: "", //付款约定
        liabilityPeriod: "", //缺陷责任期
        typeKey: "", //合同分类KEY
        typeValue: "", //合同分类VALUE
        updateTime: "", //更新时间
        createTime: "",
        isDeleted: 0,
        generalContractProjectDetailsVOs: [], //工程量清单预算列表
        contractItemVOs: [], //附件列表
        contractType: "", //是否追加合同，TEMPORARY临时，ADDITIONAL追加
        relatedId: "", //关联ID，跳转用
        relatedSerialNumberShow: "", //关联编号，展示字段
        projectDetailsTotalPrice:null, //工程量清单-汇总金额
      },
    };
  },
  mounted() {
    this.currentUserId = sessionStorage.getItem("currentUserId");
    this.dialogForm.applyUserName = sessionStorage.getItem("name");
    this.dialogForm.applyDeptId = sessionStorage.getItem("deptId");
    this.getContractCode(this.category);
    let ch = document.documentElement.clientHeight - 60;
    document.getElementsByClassName("SelectlContractDetail")[0].style.height =
      ch + "px";
    window.onresize = () => {
      return (() => {
        let ch1 = document.documentElement.clientHeight - 60;
        document.getElementsByClassName(
          "SelectlContractDetail"
        )[0].style.height = ch1 + "px";
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.activeName = "first";
      this.approveFlag = this.tabRouteParam?.approveFlag ?? "";
      this.RouteParam = this.tabRouteParam;
      this.contractId = parseInt(this.tabRouteParam.id);
      this.getContractDetail(this.contractId); //获取一条总包合同
    },

    //打开追加总包合同详情
    openContract() {
      let param = {};
      param.id = this.dialogForm.relatedId;
      param.routeId = "mineReVisitList";
      this.bus.$emit("navMenuChange", {
        routeId: "mineReVisitList",
        routeParam: param,
      });
    },

    

    close1() {
      if (this.approveFlag) {
        goBackApprove(this.approveFlag,'relationWorkList')
      } else {
        this.bus.$emit("tabClose", "mineReVisitList");
        this.bus.$emit("navMenuChange", {
          routeId: "payment-cycle",
        });
      }
    },
    close() {
      let that = this;
      this.$router.back();
    },
    //获取一条总包合同信息
    getContractDetail(val) {
      if (this.RouteParam) {
        let param = {};
        param.id = val;
        getContractDetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.dialogForm = res.data;
              this.Fornmat(0);
              if (
                this.dialogForm.approveUserId == this.currentUserId &&
                this.dialogForm.approveStatus == 2
              ) {
                this.approveFlag = true;
              }
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },

    //获取合同分类下拉框数据
    getContractCode(category) {
      let param = {};
      param.category = category;
      getBasicDataListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (category == "GENERALCONTRACTTYPE") {
              this.ContractClassList = res.data; //总包合同分类
            } else {
              this.contractCodeList = res.data; //总包合同编码
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    Fornmat(val) {
      if (val == 1) {
        //合同金额
        this.dialogForm.amount = numFilter(this.dialogForm.amount);
      } else if (val == 2) {
        //暂定金金额
        this.dialogForm.provisionalAmount = numFilter(
          this.dialogForm.provisionalAmount
        );
      } else {
        this.dialogForm.amount = numFilter(this.dialogForm.amount);
        this.dialogForm.provisionalAmount = numFilter(
          this.dialogForm.provisionalAmount
        );
        this.dialogForm.indirectExp = numFilter(this.dialogForm.indirectExp);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.SelectlContractDetail {
  height: 100%;
  background-color: white;
  /*width: calc(100% - 40px);*/
  overflow: hidden;
  .tabWrap {
    height: calc(100% - 60px);
    //  /deep/.el-tabs__item.is-top.is-active {
    //   background-color: #ffffff;
    // }

    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0 20px 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }
        .el-cascader {
          width: 100%;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
  }
  .bottomBtn {
     position: fixed;
    // border-top: 1px solid #e6e6e6;
    // width: 72%;
     height: 44px;
    line-height: 44px;
    text-align: center;
    left: 620px;
    bottom:28px ;
  }
}
 /deep/.ApproveItem .bottomBtn{
      bottom: 32px;
      z-index: 10;
      left: 500px;
    }

.el-container {
  position: relative;
  width: 100%;
  min-height: 100%;
  /*设置padding-bottom值大于等于footer的height值，以保证main的内容能够全部显示出来而不被footer遮盖；*/
  padding-bottom: 40px;
  box-sizing: border-box;
}
/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
.btnList {
  text-align: center;
  margin-top: 20px;
}
.screenPanel {
  text-align: left;
  height: auto;
  padding-bottom: 16px;
  margin-top: 20px;
  border-bottom: 1px solid #e6e6e6;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}
.firstTab {
  width: 72%;
}
@media only screen and(max-width:1680px) {
  .firstTab {
    width: 90%;
  }
}
</style>

<style scoped>
.hidden >>> .el-upload--picture-card {
  display: none;
}
</style>
